import React from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import { Button, OverlayTrigger, Modal } from 'react-bootstrap'
import { IoIosInformationCircle as InformationIcon } from 'react-icons/io'
import { IoMdInformationCircleOutline as InfoIcon } from 'react-icons/io'
import { APPConfig, convertToBoolean } from 'config/appConfig'
import {
  subscriptionContainer,
  cartContainer,
  storeContainer,
} from 'src/models'
import { i18nTranslate, currencyFormat, trackGTMEvents } from 'src/utils'
import { FreeGiftsModal } from 'src/views/components/FlexibleSubscription/SubscriptionNextOrders/FreeGiftsModal'
import { SubscriptionInfiniteScrollV2 } from 'src/views/components/SubscriptionInfiniteScrollV2'
import { NextOrderProductDetails } from './NextOrderProductDetails'
import { OrderNowModal } from './OrderNowModal'
import { OrderSkipModal } from './OrderSkipModal'
import PVCV from '../PVCV'
import ScanInfoModal from '../ScanInfoModal'
import { PromoWalletCheckout } from 'src/views/components/CheckoutAccordions/PromoWalletCheckout'
import {
  canAllowToSkipDeleteChange,
  currentMonthV2,
  currentYearV2,
  constructDateV2,
} from 'src/deps'
import './styles.scss'

@observer
class SubscriptionNextOrderView extends React.Component {
  @observable showFreeGiftsModal = false
  @observable showOrderNowModal = false
  @observable showSkipModal = false
  @observable currentProcessDate = new Date()
  @observable isInfoModalEnabled = false
  @observable infoModalType = ''
  @observable isToShowTaxInfoModal = false
  isSkipmentSkip = false
  productCount = 0
  togglesFreeGiftsModal = () => {
    this.showFreeGiftsModal = !this.showFreeGiftsModal
  }
  togglesOrderNowModal = () => {
    this.showOrderNowModal = !this.showOrderNowModal
  }

  togglesSkipModal = (isSkipped, skipGTMtrack = false) => {
    if (!skipGTMtrack) {
      trackGTMEvents({
        price: this.getTotalPriceValue('originalPrice'),
        type: 'next orders',
        event: isSkipped ? 'unskip shipment no' : 'skip shipment no',
        message: isSkipped ? '' : subscriptionContainer.skipDeleteLoyaltyMFEMsg,
      })
    }
    this.showSkipModal = !this.showSkipModal
  }
  renderProductWrapper = (
    product,
    selectedMonth,
    selectedDate,
    canSkipOrDelete = false,
    isSkipmentSkips = false,
    canChangeFrequencyToOneTime = false
  ) => {
    const data = {
      ...product,
      selectedMonth,
      selectedDate,
    }
    const subscriptionsResponse =
      subscriptionContainer.flexibleSubscriptionResponse
    return (
      <div
        key={`${product.id}-${selectedMonth}-${selectedDate}`}
        className="product-wrapper subs-product-wrapper">
        <div>
          <NextOrderProductDetails
            data={data}
            {...this.props}
            selectedMonth={selectedMonth}
            canSkipOrDelete={canSkipOrDelete}
            canChangeFrequencyToOneTime={canChangeFrequencyToOneTime}
            toggleScanInfoModal={this.toggleScanInfoModal}
            isSkipmentSkips={isSkipmentSkips}
          />
        </div>
      </div>
    )
  }
  getOnetimeTotalPrice = () => {
    let totalValue = 0
    const inventoryErrorStatus = ['out of stock', 'discontinued']
    subscriptionContainer?.selectedSubscription?.forEach(obj => {
      if (
        obj?.type === 'VARIABLE_SINGLE_ORDER' &&
        !inventoryErrorStatus.includes(
          obj?.itemInfo?.[0]?.skus?.[0]?.inventory?.toLowerCase()
        ) &&
        obj?.status === 'ACTIVE'
      ) {
        totalValue += obj?.itemInfo?.[0]?.totalValue?.originalPrice || 0
      }
    })
    return totalValue
  }
  getMonthlyTotalValue = (label = '') => {
    let monthlyTotal = 0
    const primaryTransactionOrder =
      subscriptionContainer?.subscriptionPreferenceResponse?.order || {}
    const primaryTransactionValue = primaryTransactionOrder?.[label] || 0
    monthlyTotal = monthlyTotal + primaryTransactionValue
    const migratedTransactionValue =
      subscriptionContainer?.subscriptionPreferenceResponse?.transaction || {}
    const transactionArray = Object.values(migratedTransactionValue) || []
    transactionArray?.forEach(item => {
      let itemValue = item?.[label] || 0
      monthlyTotal = monthlyTotal + itemValue
    })
    return monthlyTotal
  }
  getCartPromotions = () => {
    const itemPromotions = []
    if (subscriptionContainer?.flexibleSubscriptionResponse?.length > 0) {
      subscriptionContainer?.flexibleSubscriptionResponse?.[0]?.subscriptions?.forEach(
        item => {
          let promotion = item?.itemInfo?.[0]?.promotions || []
          if (promotion.length > 0) {
            itemPromotions.push(...promotion)
          }
        }
      )
    }

    let promotionDetails =
      subscriptionContainer?.subscriptionPreferenceResponse?.promotionDetails
        ?.promotions || []
    let result = []
    const overallPromotions = [...itemPromotions, ...promotionDetails]
    overallPromotions?.map(promotion => {
      const promoBreakup = promotion?.breakup || []
      const promoBreakupWithDiscount = promoBreakup?.filter(promo => {
        return (
          promo?.isGift ||
          (promo?.totalValue && promo?.identifier.toLowerCase() != 'loyalty')
        )
      })
      result.push(...promoBreakupWithDiscount)
    })
    return result
  }

  freeProducts = () => {
    let skus = []
    let freeGiftProducts = []
    const items = cartContainer?.cartResponse?.items
    items?.map(item => {
      if (item.properties && item.properties.isGiftItem) {
        freeGiftProducts.push(item)
      }
    })
    if (freeGiftProducts.length > 0) {
      for (let i = 0; i < freeGiftProducts.length; i++) {
        if (freeGiftProducts[i]?.skus?.[0]?.skuId)
          skus.push(freeGiftProducts[i].skus[0].skuId)
      }
    }
    return skus
  }
  renderCartPromotions = (promoBreakup = []) => {
    let tempPromoArray = []
    return promoBreakup?.map((promotion, index) => {
      // const NotOutOfStock = promotion?.isGift
      //   ? this.freeProducts()?.includes(promotion?.skuId)
      //   : true
      const NotOutOfStock = true
      const displayMessage = promotion?.displayMessage || ''
      const message = promotion?.message || displayMessage || ''
      if (!tempPromoArray?.includes(promotion?.identifier)) {
        tempPromoArray?.push(promotion?.identifier)
        return (
          <>
            {NotOutOfStock && (
              <div className="cart-promotions" key={index}>
                {message}
              </div>
            )}
          </>
        )
      }
    })
  }
  renderPromotionsToolTip = () => {
    /* to display cartLevelPromotions as tooltip*/
    const cartPromotions = this.getCartPromotions()
    if (cartPromotions?.length) {
      const promotionsView = this.renderCartPromotions(cartPromotions)
      return (
        <>
          <OverlayTrigger
            placement="top-end"
            trigger="hover"
            delay={{ show: 100, hide: 250 }}
            overlay={
              <div
                className="promotions-tooltip"
                data-testid="qa-subscription-discount-tool-tip">
                {promotionsView}
              </div>
            }>
            <InformationIcon className="cart-promo-info-icon" />
          </OverlayTrigger>
        </>
      )
    }
    return <></>
  }

  toggleInfoModal = () => {
    this.isToShowTaxInfoModal = !this.isToShowTaxInfoModal
  }

  get invalidSubscriptionPromoCodes() {
    const codes =
      subscriptionContainer?.subscriptionPreferenceResponse?.promotionDetails
        ?.codes || []
    return codes.filter(code => [false, 'false'].includes(code?.isValid))
  }

  getTotalInclusiveTax = (totalInclusiveTax = 0) => {
    return (
      <div
        className="inclusive-tax-text"
        data-testid="qa-inclusive-tax-enabled">
        <p data-testid="qa-total-inclusive-tax" className="mb-0">
          {i18nTranslate('subscription.totalInclusiveTax', 'Taxes')}
        </p>
        <Button
          className="inclusive-tax-info-button p-0"
          onClick={this.toggleInfoModal}>
          <InformationIcon
            size={20}
            data-testid="qa-inclusive-tax-info-icon"
            className="inclusive-tax-info-icon"
          />
        </Button>
      </div>
    )
  }

  getInclusiveTaxInfo = () => {
    const disableTaxSplitInfoSummary = convertToBoolean(
      APPConfig?.getAppConfig()?.disableTaxSplitInfoSummary
    )
    return (
      <div>
        {!disableTaxSplitInfoSummary && (
          <>
            <p data-testid="qa-summary-declined-messages">
              {i18nTranslate(
                'checkout.summary.declinedMessage',
                'If your card was declined and has funds, please contact your issuing bank to authorize the purchase.'
              )}
            </p>
            <p data-testid="qa-summary-hoursToProcess-messages">
              {i18nTranslate(
                'checkout.summary.hoursToProcess',
                'The order takes 24-48 hours to process after payment is made.'
              )}
            </p>
          </>
        )}
        <p data-testid="qa-summary-totalTaxes-messages">
          {i18nTranslate(
            'checkout.summary.totalTaxes',
            'The total taxes include:'
          )}
        </p>
        <ul>
          <li data-testid="qa-summary-productTax-messages">
            {i18nTranslate(
              'checkout.summary.productTax',
              'Product Tax (Included in the product price)'
            )}
          </li>
          <li data-testid="qa-summary-shippingTax-messages">
            {i18nTranslate(
              'checkout.summary.shippingTax',
              'Shipping Tax (Included in the total shipping)'
            )}
          </li>
          {!disableTaxSplitInfoSummary && (
            <>
              <li data-testid="qa-summary-categoryTax-messages">
                {i18nTranslate(
                  'checkout.summary.categoryTax',
                  'Tax Category Tax'
                )}
              </li>
              <li data-testid="qa-summary-regionalTax-messages">
                {i18nTranslate(
                  'checkout.summary.regionalTax',
                  'Regional Tax (If applicable)'
                )}
              </li>
            </>
          )}
        </ul>
      </div>
    )
  }

  renderTaxInfoModalContent = () => {
    return (
      <Modal
        className="tax-info-modal"
        show={this.isToShowTaxInfoModal}
        onHide={this.toggleInfoModal}
        centered>
        <Modal.Header className="border-0 p-0" closeButton />
        <Modal.Body className="border-0 p-0">
          {this.getInclusiveTaxInfo()}
        </Modal.Body>
      </Modal>
    )
  }

  getTotalPriceValue = (label = '') => {
    const subscriptionsResponse =
      subscriptionContainer.subscriptionPreferenceResponse || {}
    let totalValue = 0
    const primaryTransactionOrder = subscriptionsResponse?.order?.value || {}
    const primaryTransactionValue = primaryTransactionOrder?.[label] || 0
    totalValue = totalValue + primaryTransactionValue
    const migratedTransactionValue = subscriptionsResponse?.transaction || {}
    const transactionArray = Object.values(migratedTransactionValue) || []
    transactionArray?.forEach(item => {
      let itemValue = item?.value?.[label] || 0
      totalValue = totalValue + itemValue
    })
    return totalValue
  }
  formatPrice = (label = '') => {
    const subscriptionsResponse =
      subscriptionContainer.subscriptionPreferenceResponse || {}
    const primaryTransactionOrder = subscriptionsResponse?.order?.value || {}
    const primaryTransactionValue = primaryTransactionOrder?.[label] || 0
    let price = primaryTransactionValue || '0.00'
    if (isNaN(price)) {
      price = '0.00'
    }
    return price
  }
  renderSubSummary = isSkipmentSkips => {
    const {
      nextProcessDate,
      toShowOTPError = false,
      selectedMonth,
      isUpcomingDate = false,
      processNowFlagsForOneTime,
      activeCount,
    } = this.props
    const isInclusiveTaxEnable =
      convertToBoolean(
        APPConfig?.getAppConfig()?.taxConfig?.inclusiveTaxEnabled
      ) &&
      !convertToBoolean(
        APPConfig?.getAppConfig()?.taxConfig?.isPriceExclusiveMarket
      )
    const enableSubscriptionPromocode = convertToBoolean(
      storeContainer.getStoreConfigProperty('subscriptionsConfig')
        ?.enableSubscriptionPromocode || false
    )
    const totalInclusiveTax = isInclusiveTaxEnable
      ? this.formatPrice('totalInclusiveTax')
      : ''
    const date = new Date()
    const subscriptionsResponse =
      subscriptionContainer.subscriptionPreferenceResponse || {}
    const primaryTransactionOrder = subscriptionsResponse?.order?.value || {}
    const currentMonth = date.getMonth()
    const orderNowEnabled = currentMonth === selectedMonth
    const onTimePrice = this.getOnetimeTotalPrice()
    const oneTimeSubsPrice = currencyFormat({
      price: onTimePrice || 0,
    })
    let itemPrice = this.getTotalPriceValue('originalPrice')
    const itemsPriceTotal = currencyFormat({
      price: itemPrice || 0,
    })
    if (onTimePrice > 0) {
      itemPrice -= onTimePrice
    }
    const shippingAndHandeling = this.getTotalPriceValue('cartDeliveryCharge')
    const itemsPrice = currencyFormat({
      price: itemPrice || 0,
    })
    const shippingAndHandelingPrice = currencyFormat({
      price: shippingAndHandeling || 0,
    })
    const subscribeAndSave = this.getTotalPriceValue('overAllDiscount')
    const subscribeAndSavePrice = currencyFormat({
      price: subscribeAndSave || 0,
    })
    const monthlyPrice = this.getMonthlyTotalValue('monthlyTotal')
    const orderTotalPrice = currencyFormat({
      price: monthlyPrice || 0,
    })
    const overAllTax = this.getTotalPriceValue('overAllTax')
    const overAllTaxPrice = currencyFormat({
      price: overAllTax || 0,
    })
    const otherCharges = this.getTotalPriceValue('otherChargesIncludingTax')
    const otherChargesIncludingTax = currencyFormat({
      price: otherCharges || 0,
    })
    const buttonLabel = isSkipmentSkips
      ? i18nTranslate('subscription.unSkipShipment', 'Undo skip shipment')
      : i18nTranslate('subscription.skipShipment', 'Skip Shipment')
    const invalidSubscriptionPromoCodes = this.invalidSubscriptionPromoCodes
    const invalidPromoCodesArray =
      invalidSubscriptionPromoCodes
        ?.map?.(promo => promo?.code)
        ?.filter?.(Boolean) || []
    const andText = i18nTranslate('review.andText', 'and')
    const invalidPromoCodes =
      invalidPromoCodesArray.length > 1
        ? `${invalidPromoCodesArray.slice(0, -1).join(', ')} ${andText} ${invalidPromoCodesArray[invalidPromoCodesArray.length - 1]}`
        : invalidPromoCodesArray[0] || ''
    const shouldDisableOrderNowByInvalidPromo =
      invalidPromoCodesArray.length > 0
    const customClass =
      toShowOTPError ||
      !orderNowEnabled ||
      processNowFlagsForOneTime?.toDisableSubmitOrder ||
      subscriptionContainer?.ccCardExpired ||
      shouldDisableOrderNowByInvalidPromo
        ? 'disable'
        : ''
    const priceFacets = subscriptionsResponse?.order?.totalPriceFacets || {}
    const disableTabIndex = customClass === 'disable' ? -1 : 0

    return (
      <div
        data-testid="qa-subscription-order-summary-container"
        className="sub-sum-container">
        <div className={`${isSkipmentSkips && `disable`}`}>
          {isSkipmentSkips ? (
            <div
              className="sub-sum-skipped-message"
              data-testid="qa-order-skipped-message">
              {i18nTranslate(
                'subscription.orderHasBeenSkippedDescription',
                'This order has been skipped, click on "Undo skip shipment" to make changes'
              )}
            </div>
          ) : (
            <>
              <div
                className="sub-sum-process-label"
                data-testid="qa-date-process-on-text">
                {i18nTranslate(
                  'subscription.orderWillProcessOn',
                  'This order will process on'
                )}
              </div>
              <div
                className="sub-sum-process-date"
                data-testid="qa-date-process-on-value">
                {nextProcessDate}
              </div>
            </>
          )}
          <button
            className={`sub-sum-button-order ${customClass}`}
            data-testid="qa-subscription-order-now-button"
            tabIndex={disableTabIndex}
            disabled={
              subscriptionContainer?.ccCardExpired ||
              shouldDisableOrderNowByInvalidPromo ||
              false
            }
            onClick={this.togglesOrderNowModal}>
            {i18nTranslate('subscription.orderNowButton', 'Order Now')}
          </button>
          {shouldDisableOrderNowByInvalidPromo && (
            <div
              className="sub-sum-invalid-promo-alert"
              data-testid="qa-subscription-invalid-promo-alert"
              role="alert">
              {String(
                i18nTranslate(
                  'subscription.invalidRecurringPromoCode',
                  `This <<promocode>> is expired/inactive, so it could not be added to recurring orders`
                )
              ).replace('<<promocode>>', invalidPromoCodes)}
            </div>
          )}
          <h5 className="sub-sum-title" data-testid="qa-sub-order-summary">
            {i18nTranslate('orderSummary.orderSummaryTitle', 'Order Summary')}
          </h5>
          <table className="sub-sum-price-table">
            {itemPrice > 0 && (
              <tr data-testid="qa-subscription-items-sub-total">
                <td>
                  {i18nTranslate(
                    'subscription.subscriptionItemsTotal',
                    'Subscription items subtotal'
                  )}
                </td>
                <td>{itemsPrice}</td>
              </tr>
            )}
            {onTimePrice > 0 && (
              <tr data-testid="qa-subscription-one-time-sub-total">
                <td>
                  {i18nTranslate(
                    'subscription.OneTimeSubtotal',
                    'One-time subtotal'
                  )}
                </td>
                <td>{oneTimeSubsPrice}</td>
              </tr>
            )}
          </table>

          <div className="sub-sum-divider" />

          <table className="sub-sum-price-table">
            <tr data-testid="qa-subscription-subtotal">
              <td>{`${i18nTranslate('cart.subtotal', 'Subtotal')} (${
                primaryTransactionOrder?.count || 0
              } ${i18nTranslate('cart.cartItems', 'items')})`}</td>
              <td>{itemsPriceTotal}</td>
            </tr>
            <tr data-testid="qa-subscription-shipping">
              <td>{i18nTranslate('shipping', 'Shipping')}</td>
              <td>{shippingAndHandelingPrice}</td>
            </tr>
            {!isInclusiveTaxEnable && (
              <tr data-testid="qa-subscription-sales-tax">
                <td>{i18nTranslate('subscription.SalesTax', 'Sales Tax')}</td>
                <td>{overAllTaxPrice}</td>
              </tr>
            )}

            {subscribeAndSave > 0 && (
              <tr data-testid="qa-subscription-discount">
                <td>
                  {i18nTranslate('cart.discount', 'Discount')}{' '}
                  <>{this.renderPromotionsToolTip()}</>
                </td>
                <td>{`${
                  subscribeAndSave > 0 ? '-' : ''
                } ${subscribeAndSavePrice}`}</td>
              </tr>
            )}
            {otherCharges > 0 && (
              <tr data-testid="qa-subscription-other-charges">
                <td>
                  {i18nTranslate('subscription.otherCharges', 'Other Charges')}
                </td>
                <td>{otherChargesIncludingTax}</td>
              </tr>
            )}
            <tr data-testid="qa-subscription-total">
              <td className="sub-sum-total-cell">
                {i18nTranslate('cart.total', 'Total')}
              </td>
              <td className="sub-sum-total-cell">{orderTotalPrice}</td>
            </tr>
          </table>

          <div className="sub-sum-divider table-divider " />

          {isInclusiveTaxEnable && (
            <table className="sub-sum-price-table">
              <tr data-testid="qa-inclusiveTax-enbaled">
                <td>{this.getTotalInclusiveTax()}</td>
                <td>{totalInclusiveTax}</td>
              </tr>
            </table>
          )}
          <PVCV
            data-testid="qa-subscription-total-sv"
            priceFacets={priceFacets}
            isTotal={true}
          />
          {enableSubscriptionPromocode && isUpcomingDate && (
            <div className="sub-sum-coupon-container">
              <PromoWalletCheckout
                math={{ grandTotal: monthlyPrice }}
                isFromSubscription={true}
              />
            </div>
          )}

          <div className="sub-sum-divider coupon-divider" />
        </div>
        <button
          data-testid="qa-subscription-button-skip"
          className="sub-sum-button-skip"
          onClick={() => this.togglesSkipModal('', true)}>
          {buttonLabel}
        </button>
      </div>
    )
  }

  skipSkipment = (processDay, isSkipped, month) => {
    trackGTMEvents({
      price: this.getTotalPriceValue('originalPrice'),
      type: 'next orders',
      event: isSkipped ? 'unskip shipment' : 'skip shipment',
      message: isSkipped ? '' : subscriptionContainer.skipDeleteLoyaltyMFEMsg,
    })
    this.props.handleSkipShipment(processDay, isSkipped, month)
  }

  toggleScanInfoModal = (infoModalType = '') => {
    this.infoModalType = infoModalType
    this.isInfoModalEnabled = !this.isInfoModalEnabled
  }

  renderGroupProduct = (
    group,
    selectedMonth,
    subscriptions,
    gifts,
    key,
    minFrequencyPeriod
  ) => {
    const subscriptionsResponse =
      subscriptionContainer.subscriptionPreferenceResponse || {}
    let isSkipmentSkips = false
    const selectedDate = parseInt(group?.[0] || 1)
    const subscriptionIds = group?.[1]?.subscriptionIds || ''
    const { ProcessDate } = this.props
    if (group?.[1]?.isSkipped && group?.[1]?.isSkipped === 'true') {
      isSkipmentSkips = true
    } else {
      isSkipmentSkips = false
    }
    let currentMonth = currentMonthV2() || 0
    const currentYear = currentYearV2()
    const isNextYearMonth = currentMonth > selectedMonth - 1
    const year = isNextYearMonth ? parseInt(currentYear) + 1 : currentYear
    const date = ProcessDate < 10 ? `0${ProcessDate}` : ProcessDate
    const currentProcessDate = constructDateV2(year, selectedMonth - 1, date)
    // const { subscriptionIds = '', selectedDate } = group
    let subscriptionsArray = {}
    const subscriptionListIds = subscriptionIds?.split(',') || []
    subscriptionsArray = subscriptions?.filter(item => {
      const id = item.id
      return subscriptionListIds.includes(id.toString())
    })
    subscriptionsArray.sort((a, b) =>
      a.type === 'VARIABLE_SINGLE_ORDER' ? 1 : -1
    )
    this.productCount = subscriptionsArray.length
    const monthlyPrice = this.getMonthlyTotalValue('monthlyTotal')
    const itemsPriceTotal = currencyFormat({
      price: monthlyPrice || 0,
    })
    const cardNumber = subscriptionsResponse?.payment?.cardNumber || ''
    return (
      <div className="subscription-next-order-section">
        <div className="subscription-next-order-search-section">
          <SubscriptionInfiniteScrollV2 addButtonType="plus" {...this.props} />
        </div>
        <div className={`subscription-next-order-left-section `}>
          {subscriptionsArray?.map(product => {
            const {
              canSkipOrDelete = false,
              canChangeFrequencyToOneTime = false,
            } = canAllowToSkipDeleteChange(subscriptionsArray, product)
            return this.renderProductWrapper(
              product,
              selectedMonth,
              selectedDate,
              canSkipOrDelete,
              isSkipmentSkips,
              canChangeFrequencyToOneTime
            )
          })}
        </div>
        <div className="subscription-next-order-right-section">
          {gifts?.length > 0 && (
            <div
              className={`free-gift-section ${isSkipmentSkips && `disable`}`}>
              <Button
                data-testid="qa-subscription-free-gift-text"
                className="free-gift-text"
                variant="link"
                onClick={this.togglesFreeGiftsModal}>
                {i18nTranslate(
                  'freegift.yourOrder',
                  'Free Gift(s) on Your Order',
                  {
                    nameSpace: 'ssr-resource',
                  }
                )}
                <InfoIcon size={15} />
              </Button>
            </div>
          )}
          {this.showFreeGiftsModal && (
            <FreeGiftsModal
              show={this.showFreeGiftsModal}
              onHide={this.togglesFreeGiftsModal}
              subscriptions={gifts}
            />
          )}
          {this.showOrderNowModal && (
            <OrderNowModal
              show={this.showOrderNowModal}
              onHide={this.togglesOrderNowModal}
              itemsPriceTotal={itemsPriceTotal}
              cardNumber={cardNumber}
              {...this.props}
            />
          )}
          {this.showSkipModal && (
            <OrderSkipModal
              show={this.showSkipModal}
              onHide={this.togglesSkipModal}
              isSkipmentSkip={isSkipmentSkips}
              currentProcessDate={currentProcessDate}
              skipSkipment={this.skipSkipment}
              itemPrice={this.getTotalPriceValue('originalPrice')}
              minFrequencyPeriod={minFrequencyPeriod}
              {...this.props}
            />
          )}

          {this.renderSubSummary(isSkipmentSkips)}
        </div>
      </div>
    )
  }
  renderGroup = GroupProducts => {
    const {
      subscriptionGroup = {},
      selectedMonth,
      subscriptions,
      gifts = {},
    } = GroupProducts

    const minFrequencyPeriod = Math.min(
      ...(subscriptions?.map(sub => sub?.frequencyPeriod) || [0])
    )

    const subscriptionGroupList = Object.entries(subscriptionGroup)
    return (
      <div>
        {subscriptionGroupList.length > 0 && (
          <div className="subscription-next-order-wrapper">
            {subscriptionGroupList.map((group, key) => {
              return this.renderGroupProduct(
                group,
                selectedMonth,
                subscriptions,
                gifts,
                key,
                minFrequencyPeriod
              )
            })}
          </div>
        )}
      </div>
    )
  }
  render() {
    const subscriptionsResponse =
      subscriptionContainer.flexibleSubscriptionResponse
    return (
      <div className="mt-4">
        {subscriptionsResponse?.map(GroupProducts => {
          return this.renderGroup(GroupProducts)
        })}
        <ScanInfoModal
          infoModalType={this.infoModalType}
          isInfoModalEnabled={this.isInfoModalEnabled}
          toggleScanInfoModal={this.toggleScanInfoModal}
        />
        {this.isToShowTaxInfoModal && this.renderTaxInfoModalContent()}
      </div>
    )
  }
}
export default SubscriptionNextOrderView
export { SubscriptionNextOrderView }
